import { Loading, StylovyzeComposableDialog, } from '@innovyze/stylovyze/lib/components';
import { Formik } from 'formik';
import React from 'react';
import { STATUS_ENUM } from '@innovyze/stylovyze/lib/types';
import { UserEmulationBody } from './UserEmulationBody';
import { UserEmulationFooter } from './UserEmulationFooter';
import { UserEmulationLoading } from './UserEmulation.styles';
import { UserEmulationSchema } from '@innovyze/stylovyze/lib/types/userEmulation.types';
import { selectUserEmulation } from '@innovyze/stylovyze/lib/selectors/userEmulation.selectors';
import { useGlobalization } from '@innovyze/stylovyze/lib/contexts';
import { useSelector } from 'react-redux';
export const UserEmulationModal = ({ open, setOpen, }) => {
    const { t } = useGlobalization();
    const { status, errorMsg } = useSelector(selectUserEmulation);
    return (React.createElement(Formik, { validationSchema: UserEmulationSchema, initialValues: { email: '' }, initialErrors: { email: 'Please input an email address.' }, enableReinitialize: true, onSubmit: () => { } }, () => {
        return (React.createElement(StylovyzeComposableDialog, { open: open, onCancel: () => {
                setOpen(false);
            }, header: t('User Emulation'), footer: status == STATUS_ENUM.PENDING ? (React.createElement(UserEmulationLoading, null,
                React.createElement(Loading, { loading: true }))) : (React.createElement(UserEmulationFooter, { errorMsg: errorMsg, setOpen: setOpen })) },
            React.createElement(UserEmulationBody, null)));
    }));
};
export default UserEmulationModal;
